module.exports = __webpack_public_path__ + "img/Tribo5.5b97399b.webp";